	import { Navigate, Outlet, useLocation } from "react-router-dom";
	import isAuthenticated from "../../services/authService";
	import { evaluatePasswordChangeRequirement } from "../../utils/passwordChangePolicy";

	const RequireOTP = () => {
	    const auth = isAuthenticated();
	    let user = null;
	    try {
	        user = JSON.parse(sessionStorage.getItem("user") || "null");
	    } catch (e) {
	        user = null;
	    }

	    const hasUserOTP = () => {
	        if (!user?.profil?.organisme?.otpConnexion || user?.profil?.organisme?.otpConnexion === 'NONE') return true
	        else return sessionStorage.getItem('q') === '1'
	    }
	    const location = useLocation();

	    const passwordDecision = evaluatePasswordChangeRequirement(user);
	    if (auth && passwordDecision.shouldForce) {
	        return <Navigate to="/first-connexion" state={{ from: location }} replace />;
	    }

	    return hasUserOTP() && auth ? (
	        <Outlet />
	    ) : (
	        <Navigate to="/connexion" state={{ from: location }} replace />
	    );

}

export default RequireOTP
